import Image from './OC/oc-image';

const LazyImage = ({ alt, src, srcset, sizes, width, height, display }) => (
  <Image
    alt={alt}
    src={src}
    srcSet={srcset}
    sizes={sizes}
    width={width}
    height={height}
    loading="lazy"
    style={{ display }}
  />
);

export { LazyImage };
export default LazyImage;
